import type { FC, ReactElement, ReactNode } from 'react';
import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';

interface AccordionPropsTypes {
  getHeader: (
    isOpen: boolean,
    handleExpand: () => void,
  ) => ReactElement | string;
  content: ReactNode;
  isOpen?: boolean;
  isDisabled?: boolean;
  className?: string;
}

const Accordion: FC<AccordionPropsTypes> = ({
  getHeader,
  content,
  isDisabled,
  className,
  isOpen = false,
  ...restProps
}) => {
  const [height, setHeight] = useState<'auto' | number>(isOpen ? 'auto' : 0);

  const handleExpand = (): void => {
    if (isDisabled) return;

    setHeight(height === 0 ? 'auto' : 0);
  };

  return (
    <div className={className} {...restProps}>
      <div aria-expanded={height !== 0}>
        {getHeader(height !== 0, handleExpand)}
      </div>

      <AnimateHeight duration={400} height={height}>
        {content}
      </AnimateHeight>
    </div>
  );
};

export default Accordion;
